import { Row, Col, Card } from 'reactstrap';
import { useRouter } from "next/router";
import useSectors from '@/hooks/useSectors';
import useSolutions from '@/hooks/useSolutions';
import styles from './styles.module.scss';
import Link from "next/link"

export const SectorsSolutionsCTA = ({
    className,
    sectorsTitle,
    heading,
    sectorsLink,
    solutionsTitle,
    solutionsHeading,
    solutionsLink,
}) => {

    const { asPath } = useRouter();
    const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

    const sectors = useSectors({locale});
    const solutions = useSolutions({locale});

    return (
        <section className={`${styles.root} ${className}`}>
            <Row className="m-0 py-5">
                <Col md={6} className="left-column p-md-5 p-4">
                    {sectorsTitle &&
                        <div className="mb-4">
                            {sectorsLink ?
                                <h2 className={`${heading}`}>
                                    <Link href={sectorsLink} passHref>
                                        <a>{sectorsTitle}</a>
                                    </Link>
                                </h2>
                            :
                                <h2 className={`${heading}`}>
                                    {sectorsTitle}
                                </h2>
                            }
                        </div>
                    }
                    {sectors?.length > 1 && (
                        <div className="d-flex flex-wrap">
                            {sectors?.map((item, index) => (
                                <Card className="bg-transparent border-0 me-2 mb-2" key={index}>
                                    <Link href={`${locale}${locale == "/us/" ? "markets" : "specialisms"}/${item.url_slug}`}>
                                        <a className="rounded-5 py-2 px-4">
                                            {item.title}
                                        </a>
                                    </Link>
                                </Card>
                            ))}
                        </div>
                    )}

                </Col>
                <Col md={6} className="right-column p-md-5 p-4">
                    {solutionsTitle &&
                        <div className="mb-4">
                            {solutionsLink ?
                                <h2 className={`${solutionsHeading}`}>
                                    <Link href={solutionsLink} passHref>
                                        <a>{solutionsTitle}</a>
                                    </Link>
                                </h2>
                            :
                                <h2 className={`${solutionsHeading}`}>
                                    {solutionsTitle}
                                </h2>
                            }
                        </div>
                    }
                    {solutions?.length > 1 && (
                        <div className="d-flex flex-wrap">
                            {solutions?.map((item, index) => (
                                <Card className="bg-transparent border-0 me-2 mb-2" key={index}>
                                    <Link href={`${locale}employers/${item.url_slug}`}>
                                        <a className="rounded-5 py-2 px-4">
                                            {item.title}
                                        </a>
                                    </Link>
                                </Card>
                            ))}
                        </div>
                    )}
                </Col>
            </Row>
        </section>
    )
}

export default SectorsSolutionsCTA;
